/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Info from '@material-ui/icons/Info';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import Utils from '../../utils/utils';
import ArrowSlider from '../../components/ArrowSlider';
import styles from './OptionsBoardStyles';
import OIMODAL from '../../components/Modals/OI Modal';
import { connect } from 'react-redux';
import ActionTypes from '../../actions/types';
import { formatPercentFine } from '../../utils/numberFormatFunc';
import {
  barDataFunc,
  chartDataFunction,
  chartOptionsFunction,
  chartOptionsMobileFunc,
} from './chartConfig';
import PutBoardTable from './BasicPutBoard/basiCPutBoardWeb/putBoardTable';
import VolumeModal from './BasicCallBoard/VolumeModal';

class BasicPutBoard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      activeRow: {},
      orderBy: '',
      order: '',
      tableData: [],
      isOIchecked: false,
      modalRowData: [],
      shouldOpenModal: false,
      checked: [],
      show: false,
    };
  }

  componentDidMount() {
    const { optionsDetail, highestEdge, highestActual } = this.props;
    this.setState({ tableData: optionsDetail.slice().reverse() });
    const edge = highestEdge;
    const actual = highestActual;
    if (edge && actual && edge.rowIndex !== 0 && actual.rowIndex !== 0)
      window.scrollTo(
        0,
        edge.rowIndex * 40 + (actual.rowIndex * 40 - edge.rowIndex * 40)
      );
    setTimeout(() => {
      this.setState({ show: true });
    }, 250);
  }

  closeOIModal = () => {
    this.setState({ shouldOpenModal: false });
  };
  sortData = (type) => {
    this.setState({ orderBy: type });
    const { orderBy, order } = this.state;
    const isAsc = orderBy === type && order === 'asc';
    this.setState({ order: isAsc ? 'desc' : 'asc' });
  };
  toggleModal = (row) => {
    const { ticker, modalDate } = this.props;
    const { showModal } = this.state;

    if (showModal) {
      this.setState({ activeRow: {} });
      this.setState({ showModal: false });
    } else {
      this.setState({ activeRow: row });
      this.props.fetchOptionsDetail(
        ticker,
        row.expiry,
        row.put_call,
        row.strike,
        modalDate
      );
      this.setState({ showModal: true });
    }
  };

  render() {
    const {
      rows,
      highestEdge,
      highestActual,
      answerArrowPos,
      hideShading,
      latestPrice,
      currentPriceArrowPos,
      expiration,
      isMobile,
      optionsDetail,
      optionsDetail3,
      ticker,
      favioute,
      accessLevel,
    } = this.props;
    let putBoardWidth = '350px';
    const topPosition = isMobile ? '50px' : '91px';
    const localOD = optionsDetail.slice().reverse();
    const localOD3 = optionsDetail3;

    const timeline = Utils.generateTimeIntervalsUntil(
      9.5,
      16,
      1,
      localOD,
      'time'
    );
    const timeline2 = Utils.generateBarchatData(9.5, 16, 10, localOD, 'time');
    var lineLabels = [];
    var lineData2 = [];
    for (const [, value] of Object.entries(timeline)) {
      lineLabels.push(value.time);
      lineData2.push(formatPercentFine(value.ivol));
    }
    var lineData = localOD3.map((opt) => opt.last);

    const barLabel = [];
    const barActualData = [];

    for (const [, value] of Object.entries(timeline2)) {
      barLabel.push(value.time);
      barActualData.push(value.volume);
    }

    const hide = highestEdge.rowIndex === 0 ? true : false;
    let strikeSliderPosition = 0;
    if (rows.length > 0 && currentPriceArrowPos.rowPos) {
      const rowPos = currentPriceArrowPos.rowPos;
      if (rows[rowPos] !== undefined && rows[rowPos].hasOwnProperty('strike')) {
        const strikeDiff = rows[rowPos].strike - rows[rowPos - 1].strike;
        const priceDiff = latestPrice - rows[rowPos].strike;

        strikeSliderPosition =
          0.05 + // Offset due to arrow being slightly smaller
          rowPos +
          priceDiff / strikeDiff;
      }
    }
    const chartData = chartDataFunction(
      lineLabels,
      isMobile,
      ticker,
      lineData,
      lineData2
    );
    const chartOptions = chartOptionsFunction(ticker, lineLabels);
    const chartOptionsMobile = chartOptionsMobileFunc(ticker, lineLabels);
    const barData = barDataFunc(barLabel, barActualData);

    return (
      <div
        style={
          isMobile
            ? {}
            : { width: window.innerWidth > 2200 ? putBoardWidth : '350px' }
        }
      >
        {this.state.shouldOpenModal && (
          <OIMODAL
            accessLevel={accessLevel}
            showModal={this.state.shouldOpenModal}
            ticker={ticker}
            expiration={expiration}
            modalRowData={this.state.modalRowData}
            closeOIModal={this.closeOIModal}
            selectedDate={this.props.modalDate}
          />
        )}
        <VolumeModal
          state={this.state}
          setState={this.setState}
          chartData={chartData}
          sortData={this.sortData}
          localOD={localOD}
          chartOptionsMobile={chartOptionsMobile}
          chartOptions={chartOptions}
          barData={barData}
          toggleModal={this.toggleModal}
          keyName="Puts"
        />
        <div
          style={
            !isMobile
              ? styles.basicFlexContainerPut
              : styles.basicFlexContainerPutMobile
          }
        >
          <div
            style={{
              ...styles.putsHeaderFlexContainer,
              top: isMobile ? '0px' : '41px',
              justifyContent: 'center',
            }}
            className="sticky"
          >
            <Typography
              variant="inherit"
              component={!isMobile ? 'h3' : 'h4'}
              style={styles.putsHeader}
            >
              Puts
            </Typography>
            <IconButton
              color="primary"
              style={styles.infoButton}
              aria-label="Show Advanced Board"
              onClick={this.props.showAdvancedBoard}
            >
              <Info />
            </IconButton>
            {isMobile && (
              <Card
                style={{ ...styles.hideShadingBox, width: '30px!important' }}
              >
                <CardActions onClick={this.props.toggleShading}>
                  {!hideShading ? '+' : '-'}
                </CardActions>
              </Card>
            )}
          </div>
          <ArrowSlider
            height={highestActual.rowIndex - highestEdge.rowIndex}
            arrowPos={answerArrowPos}
            hide={hide}
            side="right"
            ref={this.arrowRef}
            isMobile={isMobile}
            warnings={isMobile ? null : this.props.warnings}
            yStartingPosition={highestEdge.rowIndex}
          />
          <PutBoardTable
            styles={styles}
            isMobile={isMobile}
            topPosition={topPosition}
            favioute={favioute}
            toggleModal={(data) => this.toggleModal(data)}
            setState={(data) => this.setState(data)}
            state={this.state}
            rows={rows}
            setWatchListData={this.props.setWatchListData}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  appState: state.appReducer,
  optionChainState: state.optionChainReducer,
});

const mapDispatchToProps = (dispatch) => ({
  setAppStateAction: (newState) =>
    dispatch({
      type: ActionTypes.SET_APP_STATE,
      payload: newState,
    }),
  setOptionChainStateAction: (newState) =>
    dispatch({
      type: ActionTypes.SET_OPTION_CHAIN_STATE,
      payload: newState,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(BasicPutBoard);



// WEBPACK FOOTER //
// ./src/Pages/OptionsBoard/BasicPutBoard.js